import { render, staticRenderFns } from "./AuthPasswordChangeGuidePopup.vue?vue&type=template&id=cfc9e4e8&"
import script from "./AuthPasswordChangeGuidePopup.vue?vue&type=script&lang=ts&"
export * from "./AuthPasswordChangeGuidePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports